import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createCustomPackage} from "../../../redux/features/packages/customPackagesSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../../UI/MainPaper";
import CustomPackagesForm from "./CustomPackagesForm";
import Breadcrumbs from "../../Navigation/Breadcrumbs";

const CustomPackagesNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.customPackages);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/packages": "Packages",
    "/packages/customs": "Custom Package ",
    "/packages/customs/new": "New Custom Package ",
  };

  const onCancel = () => {
    history.push("/packages/customs");
  };
  const onSubmit = async values => {
    const customPackageObj = {
      custom_id: null,
      ...values,
    };

    const res = await dispatch(createCustomPackage(customPackageObj));
    // If package was created successfully redirect to packages page and show user
    if (!res.error) {
      history.push({
        pathname: "/packages/customs",
        state: {
          showSuccess: true,
          snackbarContent: `Your Custom Package '${customPackageObj.name}' was successfully created!`,
          snackbarLink: `/packages/customs/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Custom Package
          </Typography>
          <CustomPackagesForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Custom Package"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default CustomPackagesNew;
